//@ts-check
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createGlobalStyle } from 'styled-components';

export const GlobalSkeletonStyles = createGlobalStyle`
  .skeleton_full_width_container {
    width: 100%;
    display: inline-block;
  }
`;

/**
 * Skeleton component
 * @typedef {Object} WithSkeletonProps
 * @property {boolean} shouldRender - if or not the children
 * @property {boolean} [enableAnimation] - if or not the skeleton animation
 * @property {React.ReactNode} children - children to render
 * @property {boolean} [fullWidthContainer] - if or not the container should take full width
 *
 * @param {import('react-loading-skeleton/dist').SkeletonStyleProps & WithSkeletonProps} props
 */
const WithSkeleton = ({ shouldRender, enableAnimation, children, fullWidthContainer, ...rest }) => {
  return shouldRender ? (
    <>{children}</>
  ) : (
    <Skeleton
      enableAnimation={enableAnimation}
      containerClassName={fullWidthContainer ? 'skeleton_full_width_container' : ''}
      {...rest}
    />
  );
};

export default WithSkeleton;
